import React from 'react';
import { useAuthenticatedInitialization } from '../hooks/AuthenticatedInitializationHook';
import Loader from '../components/UI/common/Loader';

interface PrivateRouteProps {
  children: JSX.Element;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { initialized } = useAuthenticatedInitialization()

  if (!initialized) {
    return (
      <div className='flex w-full h-screen justify-center items-center'>
        <Loader className='h-8 w-8' />
      </div>
    )
  }

  return children
};

export default PrivateRoute;
